import {
  AnalyticsIcon
} from "@/components/icons";
import { SideBarRouteOption } from "@/types";
import { BiCog } from "react-icons/bi";
import { FaGear, FaMoneyCheckDollar } from "react-icons/fa6";
import { GiHealthCapsule, GiTribunalJury, GiWinterGloves } from "react-icons/gi";

const licencingAdminRoutes: SideBarRouteOption[] = [
  {
    name: "Analytics",
    path: "/licencing-admin",
    icon: AnalyticsIcon,
  },
  /*{
    name: "Location Conf.",
    path: "/licencing-admin/locations",
    icon: FaMoneyCheckDollar,
    hasSubRoutes: true,
    routes: [
      {
        name: "country",
        path: "/licencing-admin/locations/country",
        icon: FaMoneyCheckDollar,
      },
      {
        name: "Province Configuration",
        path: "/licencing-admin/locations/province",
        icon: FaMoneyCheck,
      },
      {
        name: "District Configuration",
        path: "/licencing-admin/locations/district",
        icon: FaMoneyCheck,
      },
      {
        name: "Sector Configuration",
        path: "/licencing-admin/locations/sector",
        icon: FaMoneyCheck,
      },
    ],
  },*/
  {
    name: "Secondary Ed.",
    path: "/licencing-admin/secondary-education",
    icon: FaMoneyCheckDollar,
    hasSubRoutes: true,
    routes: [
      {
        name: "document Title",
        path: "/licencing-admin/secondary-education/document-title",
        icon: FaMoneyCheckDollar,
      },
    ],
  },
  {
    name: "Post Secondary",
    path: "/licencing-admin/post-secondary-education",
    icon: FaMoneyCheckDollar,
    hasSubRoutes: true,
    routes: [
      {
        name: "Exit Award Settings",
        path: "/licencing-admin/post-secondary-education/exitaward",
        icon: FaMoneyCheckDollar,
      },
      {
        name: "Professions Category",
        path: "/licencing-admin/post-secondary-education/professions-category",
        icon: FaMoneyCheckDollar,
      },
      {
        name: "Professions Credential",
        path: "/licencing-admin/post-secondary-education/professions-credential",
        icon: FaMoneyCheckDollar,
      },
      {
        name: "Academic Degree Program",
        path: "/licencing-admin/post-secondary-education/academic-degree-program",
        icon: FaMoneyCheckDollar,
      },
      {
        name: "Institution Configuration",
        path: "/licencing-admin/post-secondary-education/university-configuration",
        icon: FaMoneyCheckDollar,
      },
      {
        name: "document Title",
        path: "/licencing-admin/secondary-education/document-title",
        icon: FaMoneyCheckDollar,
      },
    ],
  },
  {
    name: "Control Panel",
    path: "/licencing-admin/control-panel",
    icon: FaMoneyCheckDollar,
    hasSubRoutes: true,
    routes: [
      {
        name: "Organisation Setup",
        path: "/licencing-admin/control-panel/organisation-setup",
        icon: FaMoneyCheckDollar,
      },
      {
        name: "Councils Configuration",
        path: "/licencing-admin/control-panel/councils-configuration",
        icon: GiTribunalJury
      },
      {
        name: "Bank Configuration",
        path: "/licencing-admin/control-panel/bank-configuration",
        icon: FaMoneyCheckDollar,
      },
      {
        name: "Currency Configuration",
        path: "/licencing-admin/control-panel/currency-configuration",
        icon: FaMoneyCheckDollar,
      },
      {
        name: "Corrector Configuration",
        path: "/licencing-admin/control-panel/corrector-configuration",
        icon: FaMoneyCheckDollar,
      },
      {
        name: "Services Configuration",
        path: "/licencing-admin/control-panel/services-configuration",
        icon: FaGear,
      },
      {
        name: "Study Level Configuration",
        path: "/licencing-admin/control-panel/study-level-configuration",
        icon: FaGear
      },
      {
        name: "Licence Fee Configuration",
        path: "/licencing-admin/control-panel/licence-fee-configuration",
        icon: FaMoneyCheckDollar,
      },
      {
        name: "Others Charge Configuration",
        path: "/licencing-admin/control-panel/others-charge-configuration",
        icon: FaMoneyCheckDollar,
      },
      {
        name: "News And Notification",
        path: "/licencing-admin/control-panel/news-and-notification",
        icon: FaMoneyCheckDollar,
      },
      {
        name: "Upload Documents or Download",
        path: "/licencing-admin/control-panel/upload-documents-or-Download",
        icon: FaMoneyCheckDollar,
      },
      {
        name: "Exam Setup",
        path: "/licencing-admin/control-panel/exam-setup",
        icon: FaMoneyCheckDollar,
      },
      {
        name: "Upload Signature",
        path: "/licencing-admin/control-panel/upload-signature",
        icon: FaMoneyCheckDollar,
      },
      {
        name: "Fines Configuration",
        path: "/licencing-admin/control-panel/fines-configuration", 
        icon: FaMoneyCheckDollar,
      },
    ],
  },
  {
    name: "System Settings",
    path: "/licencing-admin/system-settings",
    icon: BiCog,
    hasSubRoutes: true,
    routes: [
      {
        name: "Users Configurations",
        path: "/licencing-admin/system-settings/users",
        icon: GiWinterGloves,
      },
      {
        name: "Users Roles",
        path: "/licencing-admin/system-settings/roles",
        icon: GiHealthCapsule,
      },
      {
        name: "Approval Structure Configuration",
        path: "/licencing-admin/system-settings/approval-structure",
        icon: GiHealthCapsule,
      },
    ],
  },
];

export default licencingAdminRoutes;
